import PartNumber from './components/PartNumber'

function render( _: string, storePart: { id: number, part?: { partNumber: string } } ): JSX.Element {
	return (
		<PartNumber item={storePart} />
	)
}

export default {
	field: 'partNumber',
	name: 'MFR #',
	render
}
